var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 25 25" }, props),
    React.createElement("path", { d: "M12.476 0C5.587 0 0 5.586 0 12.476c0 5.512 3.575 10.189 8.533 11.842.623.113.853-.271.853-.604 0-.296-.011-1.279-.017-2.32-3.471.754-4.203-1.473-4.203-1.473-.568-1.444-1.386-1.827-1.386-1.827-1.132-.772.085-.758.085-.758 1.253.088 1.913 1.286 1.913 1.286 1.113 1.908 2.919 1.356 3.631 1.039.112-.81.435-1.358.791-1.67-2.771-.315-5.684-1.385-5.684-6.167 0-1.362.487-2.475 1.286-3.349-.13-.314-.558-1.582.121-3.301 0 0 1.047-.336 3.432 1.278a11.94 11.94 0 0 1 3.122-.419c1.061.004 2.129.143 3.125.419 2.384-1.614 3.43-1.278 3.43-1.278.68 1.719.25 2.987.122 3.301.801.874 1.283 1.986 1.283 3.349 0 4.792-2.918 5.847-5.696 6.157.447.385.847 1.146.847 2.309 0 1.671-.015 3.015-.015 3.424 0 .333.224.723.855.602 4.957-1.652 8.526-6.329 8.526-11.84C24.953 5.586 19.365 0 12.476 0z" })
  );
});


// WEBPACK FOOTER //
// ./src/media/icon-github.svg